import React from 'react';
// Consants
import { CompanyName, LocationCity } from '../../utils/Constants';
// Data
import {
  aboutPageAdditionalMeta,
  aboutPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import { HelmetItem } from '../../components/utils/HelmetItem';
import Navbar from '../../components/nav/Navbar';
import AboutPageMainContainer from '../../components/about/AboutPageMainContainer';
import VideoHeader from '../../components/general/VideoHeader';

const AboutPage = React.memo(() => {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Me'
        desc={`Learn more about ${CompanyName}, a professional dominatrix based in ${LocationCity}. ${CompanyName} offers tailored BDSM sessions that provide unforgettable, intimate experiences. Explore her services, expertise, and unique approach to domination.`}
        keywords={`about, ${CompanyName}, dominatrix, BDSM, professional services, intimate experiences, domination, ${LocationCity}`}
        additionalMeta={aboutPageAdditionalMeta}
        structuredData={aboutPageStructuredData} 
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour2 text-colour1 dark:bg-colour2 dark:text-colour1 font-poppins no__highlights'>
        <div className='grid grid-rows-reg lg:grid-rows-none max-h-screen min-h-screen'>
          {/* Navigation */}
          <div className='lg:hidden'>
            <Navbar />
          </div>

          {/* Header */}
          <VideoHeader />
        </div>

        {/* Main page content */}
        <AboutPageMainContainer />
      </div>
    </>
  );
});

export default AboutPage;
